import React from 'react';
import { AwarenessTemplate } from '../components/training/templates/AwarenessTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getAwarenessContent } from '../data/standards/trainingContent';

export const IATF16949Awareness = () => {
  const standard = getStandardBySlug('iatf-16949');
  const content = getAwarenessContent('iatf-16949');

  return <AwarenessTemplate standard={standard} content={content} />;
};
